<h1 mat-dialog-title>{{ data.title }}</h1>

<div class="row">
    <div *ngIf="errors && errors.length" class="error-warning">
        <div *ngFor="let error of errors">
            <fa-icon [icon]="iconWarning"></fa-icon>
            {{ error.errorMessage }}
        </div>
    </div>
</div>

<div mat-dialog-content>
    <form [formGroup]="form">
        <div class="form-container">
            <div class="row">
                <div class="col-4">
                    <bds-commodity-select
                        formControlName="commCode"
                        (selectionChange)="onCommodityChange($event)"
                        [isRequired]="false"
                        [displayValue]="displayValueCommClass"
                        [filter]="activeCommodityFilter"
                    ></bds-commodity-select>
                </div>
                <div class="col-4">
                    <bds-erpc-origin-select
                        formControlName="splc"
                        label="Origin City"
                        [enableSearchPopup]="true"
                        [enableAdd]="false"
                        [newWindowForAdd]="true"
                        [newWindowForEdit]="true"
                        [enableEdit]="false"
                        [displayValue]="displayValue"
                        [title]="'Select Origin'"
                        valueExpr="splc"
                        [searchDisplay]="SearchDisplay"
                        (selected)="onOriginCitySelected($event)"
                    >
                    </bds-erpc-origin-select>
                </div>
                <div class="col-1">
                    <mat-form-field class="full-width">
                        <mat-label>State</mat-label>
                        <input matInput formControlName="erpcState" />
                    </mat-form-field>
                </div>
                <div class="col-3">
                    <mat-form-field class="full-width">
                        <mat-label>SPLC</mat-label>
                        <input matInput formControlName="splc" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <dx-select-box
                        [stylingMode]="'filled'"
                        [class.bds-mat-dense-form-field]="dense"
                        [class.dx-mat-form-field-floatLabel-always]="matFloatLabel === 'always'"
                        class="bds-dx-custom-material flex-fill"
                        formControlName="fleetId"
                        [dataSource]="fleetDxLookupSource"
                        fieldTemplate="inputField"
                        itemTemplate="item"
                        valueExpr="fleetId"
                        [searchEnabled]="true"
                        [searchExpr]="['fleetId', 'fleetName']"
                        label="Fleet"
                    >
                        <dxo-drop-down-options minWidth="250px"></dxo-drop-down-options>
                        <div *dxTemplate="let data of 'item'">
                            <span>{{ data.fleetId }} - {{ data.fleetName }}</span>
                        </div>
                        <div *dxTemplate="let data of 'inputField'">
                            <dx-text-box
                                label="Fleet"
                                style="display: inline-block"
                                [value]="
                                    data ? kvpDisplayTemplate(data.fleetId, data.fleetName) : ''
                                "
                            ></dx-text-box>
                        </div>
                    </dx-select-box>
                </div>
                <div class="col-6">
                    <dx-select-box
                        [stylingMode]="'filled'"
                        [class.bds-mat-dense-form-field]="dense"
                        [class.dx-mat-form-field-floatLabel-always]="matFloatLabel === 'always'"
                        class="bds-dx-custom-material flex-fill"
                        formControlName="businessGroup"
                        [dataSource]="businessGroupDxLookupSource"
                        fieldTemplate="inputField"
                        itemTemplate="item"
                        valueExpr="businessGroup"
                        [searchEnabled]="true"
                        [searchExpr]="['businessGroup', 'businessGroupName']"
                        label="Business Group"
                    >
                        <dxo-drop-down-options minWidth="250px"></dxo-drop-down-options>
                        <div *dxTemplate="let data of 'item'">
                            <span *ngIf="data; else businessGroupNoItem"
                                >{{ data.businessGroup }} - {{ data.businessGroupName }}</span
                            >
                            <ng-template #businessGroupNoItem><span></span></ng-template>
                        </div>
                        <div *dxTemplate="let data of 'inputField'">
                            <dx-text-box
                                label="Business Group"
                                style="display: inline-block"
                                [value]="
                                    data
                                        ? kvpDisplayTemplate(
                                              data.businessGroup,
                                              data.businessGroupName
                                          )
                                        : ''
                                "
                            ></dx-text-box>
                        </div>
                    </dx-select-box>
                </div>
            </div>
        </div>
    </form>
</div>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!form.valid || isSaving">
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">
            <mat-spinner diameter="20"></mat-spinner>
            Saving...
        </span>
    </button>
</mat-dialog-actions>
